import { Component, OnInit } from '@angular/core';
import { debug } from 'console';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-network',
  templateUrl: './our-network.component.html',
  styleUrls: ['./our-network.component.css']
})
export class OurNetworkComponent implements OnInit {
  activeTab = "affilations";
  activeTab2 = 'Individuals';
  type = 'user'
  loading = false
  arrList
  totalItems
  objArr
  pageNo
  pageSize
  arr = [1, 2, 3, 4, 5]
  followersList
  merchantsList
  communityID
  communityData
  constructor(private authService: AuthservicesService) {
    this.pageSize = environment.pageSize
  }

  ngOnInit(): void {
    this.communityID = JSON.parse(localStorage.getItem('ministry_currentUser'))

    this.affliatedUser(1)
    this.merchantList(1)
  }
  affliatedUser(event) {
    this.objArr = [];
    this.pageNo = event
    let skip = this.authService.createSkip(this.pageNo, this.pageSize);
    this.authService.affilatedUserlist(skip, this.pageSize, this.type).subscribe((res: any) => {
      console.log("res>>>>>>>>>>>", res)
      this.loading = true
      this.arrList = res.items
      this.totalItems = res.total
      this.objArr = this.createArray(this.arrList, 'addStaff')
    },
      error => {
        console.log(error)
      })
  }

  merchantList(event) {
    this.objArr = [];
    this.pageNo = event
    let skip = this.authService.createSkip(this.pageNo, this.pageSize);
    this.authService.merchantFollowers(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.merchantsList = res.items
      this.totalItems = res.total
      this.objArr = this.createArray(this.merchantsList, '')
    },
      error => {
        console.log(error)
      })
  }


  followerList(event) {
    this.objArr = [];
    this.pageNo = event
    let skip = this.authService.createSkip(this.pageNo, this.pageSize);
    this.authService.followerList(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.followersList = res.items
      let obj = []
      this.followersList.forEach(e => {
        obj.push(e.user)
      });
      this.objArr = this.createArray(obj, '')
    },
      error => {
        console.log(error)
      })

  }


  getBlock(id) {
    if (this.activeTab2 == "Merchants") { this.getBlockMerchant(id) }
    if (this.activeTab2 == "Individuals") { this.getBlockUser(id) }
    if (this.activeTab2 == "Fellowships") { this.getBlockCommunity(id) }

  }

  getBlockMerchant(id) {
    let swall = this.authService.swal('block')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockMerchant(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.affliatedUser(this.pageNo)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }



  getBlockUser(id) {
    let swall = this.authService.swal('block')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockUser(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.affliatedUser(this.pageNo)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }

  addStaff(e) {
    let obj = {
      "individualId": e.id,
      "staffType": e.staffId,
      "name": e.name
    }

    this.authService.addStaffList(obj).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }

  getBlockCommunity(id) {
    let swall = this.authService.swal('block')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockCommmunity(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.affliatedUser(this.pageNo)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }

  // addStaff(id) {
  //   let swall = this.authService.swal('Add as staff')
  //   swall.then((result) => {
  //     if (result.value == true) {
  //       this.authService.addStaff(id).subscribe((res: any) => {
  //         this.authService.successMessage(res.message, 'success')
  //         this.affliatedUser(this.pageNo)
  //       },
  //         error => {
  //           this.authService.successMessage(error.error.message, 'error')
  //         })
  //     }
  //   })
  // }




  createArray(arr, key) {
    let obj = []
    arr.forEach((e) => {
      obj.push({
        id: (e._id) ? e._id : '',
        name: (e.name) ? e.name : '',
        email: (e.email) ? e.email : '',
        photo: (e.photo) ? this.renderImage(e.photo) : '',
        tab: this.activeTab2,
        reported: 'No',
        type: this.type,
        parentType: this.activeTab
        // addStaff: (key != '') ? 'addStaff' : ''

      })
    })
    return obj;
  }

  getScrollTo(id: string, key, type) {
    this.loading = false;
    if (key == 'parent' && type == '') {
      this.activeTab = id;
      this.type = 'user'

      if (this.activeTab == 'followers') { this.followerList(1) }
      // if (this.activeTab == 'partners') { this.communityDetail() }
    }
    if (key == 'child' && type != '') {
      this.activeTab2 = id
      this.type = type;

      if (this.activeTab2 == 'partners') { return this.communityDetail() }

    }
    if (this.type != '' && this.activeTab == 'affilations') {
      this.affliatedUser(1)
    }
    if (this.type != '' && this.activeTab2 == 'partners') { this.communityDetail() }

    const element = this.getElementById(id)

  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }

  renderImage(data) {
    return this.authService.spilturl(data)
  }


  communityDetail() {
    this.objArr = [];
    this.authService.communitydetails(this.communityID.id).subscribe((res: any) => {
      this.communityData = res.data;
      this.loading = true;
      //  this.objArr = this.createArray(this.communityData.partners)
      this.objArr = this.createArray(this.communityData.partners, '')
    },
      error => {
        console.log(error)
      })
  }


}
